import * as types from '@/store/mutations'
import api from '@/services/score.js'
//import moment from 'moment'

const getters = {
    scorelog: (state)=> state.scorelog,
    getTimeline: (state) => () => {
        return state.scorelog
    },

    getActivityPeriod: (state) => () => {
        return state.scorelog['8weekLog'];
    },


  /*
  getScoreForYearWeek: (state) => (year, week) => {
    //console.log(state);
    //console.log(year);
    //console.log(week);
    
    return null
  }
  */
}

const actions = {
    /*
    * Fetches all scorelogentries
    * */
  loadAllScores({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAllScores().then((res)=>{
        commit(types.SET_ALL_SCORELOGS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
    loadTeammemberScores(context, id){
        if(!parseInt(id)){
            console.log("store: getTeammemberScores returning null - error with id")
            return null
        }
        
        return new Promise((resolve, reject) => {
            api.getTeammemberScores({memberid:id}).then((res)=>{
                //commit(types.SET_GROUPMEMBERSCORE,res)
                resolve(res)
            }).catch((ex)=>{
                reject(ex)
            })
        })

    },
    loadTeammemberDealer(context, id){
        if(!parseInt(id)){
            console.log("store: getTeammemberDEALER returning null - error with id")
            return null
        }

        return new Promise((resolve, reject) => {
            api.getTeammemberDealer({memberid:id}).then((res)=>{
               // commit(types.SET_GROUPMEMBERDEALER,res)
                resolve(res)
            }).catch((ex)=>{
                reject(ex)
            })
        })

    },
    loadTopTenForWeek(context, params){
        return new Promise((resolve, reject) => {
          api.getTopTen(params).then((res)=>{
            resolve(res)
          }).catch((ex)=>{
            reject(ex)
          })
        })
        
    },
    loadBestscoresForWeek(context, params){
      return new Promise((resolve, reject) => {
        api.getBestscores(params).then((res)=>{
          resolve(res)
        }).catch((ex)=>{
          reject(ex)
        })
      })
      
    },
    loadTenKForWeek(context, params){
        return new Promise((resolve, reject) => {
            api.getTenKscores(params).then((res)=>{
                resolve(res)
            }).catch((ex)=>{
                reject(ex)
            })
        })
        
    },
    loadQualificationForWeek(){
        return new Promise((resolve, reject) => {
            api.getQualificationscores().then((res)=>{
                resolve(res)
            }).catch((ex)=>{
                reject(ex)
            })
        })
        
    }
}

const mutations = {
    [types.SET_ALL_SCORELOGS](state, scorelog) {
        state.scorelog = scorelog
    },
    [types.SET_GROUPMEMBERSCORE](state, groupscore) {
      state.groupscore = groupscore
    },
    [types.GET_TOPTENSCORE](state, payload) {
        state.week = payload.week
        state.mode = payload.mode
    }
}

const state = {
  scorelog: [],
  groupscore: [],
  lifetimeScore: 0,
  activePeriodScore: 0
}

export default {
  state,
  getters,
  actions,
  mutations
}
